import SignupApproval from "../models/signupApproval";
import SignupInfo from "../models/signupInfo";
import SignupInvitation from "../models/signupInvitation";
import SignupPending from "../models/signupPending";
import User from "../models/user";
import UserStat from "../models/userStat";
import httpService from "./httpService";
import localStorageService from "./localStorageService";

const apiEndpoint = "/users";

const usersActiveLiveSeconds: number = 60; // last minute

const login = async (username: string, password: string): Promise<any> => {
  const { data }: any = await httpService.post(`${apiEndpoint}/login`, {
    username,
    password,
  });
  if (data.user) {
    Object.setPrototypeOf(data.user, User.prototype);
  }
  return Promise.resolve(data);
};

const getLoggedinUser = async (): Promise<User> => {
  const { data: user } = await httpService.get<any>(
    `${apiEndpoint}/getLoggedinUser`
  );
  if (user) {
    Object.setPrototypeOf(user, User.prototype);
  }
  return Promise.resolve(user);
};

const logout = () => {
  // localStorageService.clearIdProjectCollection();
  // localStorageService.clearIdProject();
  localStorageService.clearLoginData();
  httpService.removeAccessToken();
};

const updateProfile = (
  firstName: string,
  lastName: string,
  isChangePassword: boolean,
  oldPassword: string | undefined,
  newPassword: string | undefined
) => {
  return httpService.post(`${apiEndpoint}/updateProfile`, {
    firstName,
    lastName,
    isChangePassword,
    oldPassword,
    newPassword,
  });
};

const signup = (signupInfo: SignupInfo) => {
  return httpService.post(`${apiEndpoint}/signup`, {
    ...signupInfo,
  });
};

const resendAccountConfirmation = (signupInfo: SignupInfo) => {
  return httpService.post(`${apiEndpoint}/resendAccountConfirmation`, {
    ...signupInfo,
  });
};

const confirmAccount = (accountConfirmationToken: string) => {
  return httpService.post(`${apiEndpoint}/confirmAccount`, {
    accountConfirmationToken,
  });
};

const confirmAccountByUsername = (username: string) => {
  return httpService.post(`${apiEndpoint}/confirmAccountByUsername`, {
    username,
  });
};

const approveAccountByUsername = (username: string) => {
  return httpService.post(`${apiEndpoint}/approveAccountByUsername`, {
    username,
  });
};

const forgotPassword = (email: string, resetPasswordUrl: string) => {
  return httpService.post(`${apiEndpoint}/forgotPassword`, {
    email,
    resetPasswordUrl,
  });
};

const resetPassword = (resetPasswordToken: string, newPassword: string) => {
  return httpService.post(`${apiEndpoint}/resetPassword`, {
    resetPasswordToken,
    newPassword,
  });
};

const getActiveUsers = (numberOfSecondsAgo: number) => {
  return httpService.get<UserStat[]>(
    `${apiEndpoint}/getActiveUsers?numberOfSecondsAgo=${numberOfSecondsAgo}`
  );
};

const getActiveUsersPastDays = (numberOfDaysAgo: number) => {
  return httpService.get<UserStat[]>(
    `${apiEndpoint}/getActiveUsersPastDays?numberOfDaysAgo=${numberOfDaysAgo}`
  );
};

const getSignupPendings = () => {
  return httpService.get<SignupPending[]>(`${apiEndpoint}/getSignupPendings`);
};

const getSignupPendingById = (idSignupPending: number) => {
  return httpService.get<SignupPending>(
    `${apiEndpoint}/getSignupPendingById?idSignupPending=${idSignupPending}`
  );
};

const updateSignupPending = (idSignupPending: number, email: string) => {
  return httpService.post(`${apiEndpoint}/updateSignupPending`, {
    idSignupPending,
    email,
  });
};

const deleteSignupPending = (idSignupPending: number) => {
  var data = new FormData();
  data.append("idSignupPending", idSignupPending.toString());
  return httpService.post(`${apiEndpoint}/deleteSignupPending`, data);
};

const getSignupApprovals = () => {
  return httpService.get<SignupApproval[]>(`${apiEndpoint}/getSignupApprovals`);
};

const getSignupApprovalById = (idSignupApproval: number) => {
  return httpService.get<SignupApproval>(
    `${apiEndpoint}/getSignupApprovalById?idSignupApproval=${idSignupApproval}`
  );
};

const deleteSignupApproval = (idSignupApproval: number) => {
  var data = new FormData();
  data.append("idSignupApproval", idSignupApproval.toString());
  return httpService.post(`${apiEndpoint}/deleteSignupApproval`, data);
};

const getSignupInvitations = () => {
  return httpService.get<SignupInvitation[]>(
    `${apiEndpoint}/getSignupInvitations`
  );
};

const createSignupInvitations = (signupInvitations: SignupInvitation[]) => {
  return httpService.post<SignupInvitation[]>(
    `${apiEndpoint}/createSignupInvitations`,
    signupInvitations
  );
};

const deleteSignupInvitation = (idSignupInvitation: number) => {
  return httpService.post(`${apiEndpoint}/deleteSignupInvitation`, {
    idSignupInvitation,
  });
};

const getPortalAdminUsers = () => {
  return httpService.get<User[]>(`${apiEndpoint}/getPortalAdminUsers`);
};

const getUsers = () => {
  return httpService.get<User[]>(`${apiEndpoint}/getUsers`);
};

const getUserByIdUser = (idUser: number) => {
  return httpService.get<User>(
    `${apiEndpoint}/getUserByIdUser?idUser=${idUser}`
  );
};

const resetPasswordByIdUser = (idUser: number, newPassword: string) => {
  return httpService.post(`${apiEndpoint}/resetPasswordByIdUser`, {
    idUser,
    newPassword,
  });
};

const userService = {
  login,
  getLoggedinUser,
  logout,
  updateProfile,
  signup,
  resendAccountConfirmation,
  confirmAccount,
  confirmAccountByUsername,
  approveAccountByUsername,
  forgotPassword,
  resetPassword,
  usersActiveLiveSeconds,
  getActiveUsers,
  getActiveUsersPastDays,
  getSignupPendings,
  getSignupPendingById,
  updateSignupPending,
  deleteSignupPending,
  getSignupApprovals,
  getSignupApprovalById,
  deleteSignupApproval,
  getSignupInvitations,
  createSignupInvitations,
  deleteSignupInvitation,
  getPortalAdminUsers,
  getUsers,
  getUserByIdUser,
  resetPasswordByIdUser,
};

export default userService;
